import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateConverterService {
  getTimezoneAgnosticDateIsoString(
    date: Date,
    isEndDate: boolean = false,
  ): string {
    // Adjust the date to the local Dutch timezone
    const localDate = new Date(date);

    // Set time to 00:00:00 (local time) for the start of the day
    localDate.setHours(0, 0, 0, 0);

    // If it's an end date, add one day to represent the beginning of the next day.
    // The rule to add 1 day to endDate is a technical 'business' rule. The amount of daysd to add will never exceed 1;
    // Therefore, it was decided NOT to add a param 'numbersOfDaysToAdd' but instead the bool 'isEndDate'.
    if (isEndDate) {
      localDate.setDate(localDate.getDate() + 1);
    }

    // Calculate the timezone offset in minutes and adjust the date to ensure 00:00:00 Amsterdam time
    const timezoneOffset = localDate.getTimezoneOffset() * 60000; // Offset in milliseconds
    const correctedDate = new Date(localDate.getTime() - timezoneOffset);

    // Convert the corrected date to ISO string
    const isoString = correctedDate.toISOString();
    return isoString;
  }
}
